/* Signal — helpers for custom sections. Re-inits inside the theme editor. */
(function () {
  var lang = document.documentElement.lang || 'en';

  function money(cents, currency) {
    try {
      var v = cents / 100;
      return new Intl.NumberFormat(lang, {
        style: 'currency', currency: currency || 'SEK',
        minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  /* ---------- cart drawer (Sunnies structure, registered as <cart-drawer> for Dawn) ---------- */
  var cartCfg = window.SgCart || {};
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cartCfg.root || '/';
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shopMoney(cents) {
    var f = window.SgMoneyFormat || '${{amount}}';
    var v = cents / 100;
    var sep = function (n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return f
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sep(Math.round(v).toString()).replace(/,/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sep(Math.round(v).toString()))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, sep(v.toFixed(2).split('.')[0]) + '.' + v.toFixed(2).split('.')[1]);
  }
  function sized(url, w) {
    if (!url) return '';
    try { var u = new URL(url, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }
  function glassesSvg(color) {
    return '<svg class="sg-glasses" viewBox="0 0 240 96" aria-hidden="true"><g stroke="#0C0C0C" stroke-width="8" stroke-linejoin="round" stroke-linecap="round">' +
      '<path d="M6 24Q120 4 234 24" fill="none"/>' +
      '<path d="M16 24C16 18 22 16 30 16L100 16C110 16 114 22 112 30L106 60C103 74 92 82 76 82L44 82C28 82 18 72 16 56Z" fill="' + color + '"/>' +
      '<path d="M224 24C224 18 218 16 210 16L140 16C130 16 126 22 128 30L134 60C137 74 148 82 164 82L196 82C212 82 222 72 224 56Z" fill="' + color + '"/>' +
      '<path d="M112 28Q120 20 128 28" fill="none"/></g></svg>';
  }
  function lineThumb(it) {
    if (it.image) return '<img src="' + esc(sized(it.image, 200)) + '" alt="" loading="lazy" width="84" height="84">';
    var t = (it.variant_title || '').toLowerCase();
    var lenses = cartCfg.lenses || [];
    var ph = cartCfg.photos || {};
    if (cartCfg.kitKeyword && t.indexOf(cartCfg.kitKeyword) !== -1) {
      return ph.kit ? '<img src="' + esc(ph.kit) + '" alt="" loading="lazy" width="84" height="84">'
        : '<span class="sg-line__illus sg-line__illus--kit">' + lenses.slice(0, 3).map(function (l) { return glassesSvg(l.color); }).join('') + '</span>';
    }
    var idx = lenses.findIndex(function (l) { return t.indexOf(l.name) !== -1; });
    if (idx > -1 && idx < 3 && ph['l' + (idx + 1)]) return '<img src="' + esc(ph['l' + (idx + 1)]) + '" alt="" loading="lazy" width="84" height="84">';
    return '<span class="sg-line__illus">' + glassesSvg(idx > -1 ? lenses[idx].color : '#3A3D40') + '</span>';
  }

  class SgCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('.sg-drawer__panel');
      var self = this;
      this.querySelectorAll('[data-sg-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.classList.contains('is-open')) self.close(); });
      this.addEventListener('submit', function (e) {
        if (!e.target.matches('[data-sg-code-form]')) return;
        e.preventDefault();
        var input = e.target.querySelector('input');
        var code = input.value.trim();
        if (code) self.applyCode(code).then(function (ok) { if (ok) input.value = ''; });
      });
      this.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-sg-code-remove]');
        if (rm) self.setCodes(self.codes().filter(function (c) { return c.toLowerCase() !== rm.dataset.sgCodeRemove.toLowerCase(); }));
      });
      this.addEventListener('change', function (e) {
        if (!e.target.matches('[data-sg-upsell-toggle]')) return;
        self.toggleUpsell(e.target.checked);
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-q]');
        if (!b) return;
        var line = b.closest('.sg-line');
        var cur = Number(line.querySelector('.sg-qty span').textContent), d = Number(b.dataset.q);
        self.change(line.dataset.key, d === 0 ? 0 : Math.max(0, cur + d));
      });
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href$="/cart"], #cart-icon-bubble');
        if (!a || e.metaKey || e.ctrlKey || a.closest('cart-drawer')) return;
        e.preventDefault();
        self.open();
      });
    }
    /* Dawn product-form / quick-add interface */
    getSectionsToRender() { return []; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents() { this.open(); }

    load() {
      var self = this;
      return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); return c; });
    }
    /* Upsell checkbox: update the drawer instantly, then save with a single /cart/update.js call */
    toggleUpsell(on) {
      var self = this, up = cartCfg.upsell, c = this._cart;
      if (!up) return;
      if (c) {
        var rest = c.items.filter(function (it) { return it.variant_id !== up.variantId; });
        var upTotal = c.items.reduce(function (sum, it) { return it.variant_id === up.variantId ? sum + it.final_line_price : sum; }, 0);
        var lines = on ? rest.concat([{ variant_id: up.variantId, key: '', quantity: 1, final_line_price: up.price, original_line_price: up.price }]) : rest;
        this.render(Object.assign({}, c, {
          items: lines,
          item_count: lines.reduce(function (n, it) { return n + it.quantity; }, 0),
          total_price: c.total_price - upTotal + (on ? up.price : 0),
          items_subtotal_price: (c.items_subtotal_price || c.total_price) - upTotal + (on ? up.price : 0)
        }));
      }
      this._upWant = on;
      if (!this._upBusy) this.syncUpsell();
    }
    /* one request at a time; if the box was toggled again meanwhile, send the latest state when this one returns */
    syncUpsell() {
      var self = this, up = cartCfg.upsell, want = this._upWant;
      this._upBusy = true;
      var updates = {}; updates[up.variantId] = want ? 1 : 0;
      fetch(cartRoot + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (cart) {
          if (self._upWant !== want) { self.syncUpsell(); return; }
          self._upBusy = false;
          self.render(cart);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sg-cart-drawer', cartData: cart });
        })
        .catch(function () { self._upBusy = false; self.load(); });
    }
    /* ---- discount codes (Cart API: /cart/update.js { discount: "A,B" }) ---- */
    codes() {
      return ((this._cart && this._cart.discount_codes) || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
    }
    setCodes(list) {
      var self = this;
      this.classList.add('is-loading');
      return fetch(cartRoot + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: list.join(',') })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (c) { self.render(c); return c; })
        .finally(function () { self.classList.remove('is-loading'); });
    }
    applyCode(code) {
      var self = this, msg = this.querySelector('[data-sg-code-msg]');
      var have = this.codes();
      if (have.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { this.codeMsg(code.toUpperCase() + ' is already applied.'); return Promise.resolve(true); }
      return this.setCodes(have.concat([code])).then(function (c) {
        var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) { self.codeMsg(''); return true; }
        self.codeMsg(code.toUpperCase() + (hit ? " can't be used with this cart." : ' is not a valid code.'), true);
        return hit ? self.setCodes(have).then(function () { return false; }) : false;
      }).catch(function () { self.codeMsg('Something went wrong. Please try again.', true); return false; });
    }
    codeMsg(text, isError) {
      var msg = this.querySelector('[data-sg-code-msg]');
      if (!msg) return;
      msg.textContent = text; msg.hidden = !text; msg.classList.toggle('is-error', !!isError);
    }
    add(variantId) {
      var self = this;
      this.classList.add('is-loading');
      return fetch(cartRoot + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function () { return self.load(); })
        .then(function (c) { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sg-cart-drawer', cartData: c }); })
        .finally(function () { self.classList.remove('is-loading'); });
    }
    change(key, qty) {
      var self = this;
      this.classList.add('is-loading');
      return fetch(cartRoot + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sg-cart-drawer', cartData: c }); })
        .finally(function () { self.classList.remove('is-loading'); });
    }
    render(cart) {
      this._cart = cart;
      var q = this.querySelector.bind(this);
      // the upsell (e.g. Worryfree) is shown as a checkbox, not as a line, and does not count as an item
      var up = cartCfg.upsell;
      var upLine = up ? cart.items.filter(function (it) { return it.variant_id === up.variantId; })[0] : null;
      var items = upLine ? cart.items.filter(function (it) { return it !== upLine; }) : cart.items;
      this._upKey = upLine ? upLine.key : null;
      if (upLine && !items.length) { this.change(upLine.key, 0); return; }
      var count = cart.item_count - (upLine ? upLine.quantity : 0);
      q('[data-sg-drawer-count]').textContent = '(' + count + ')';
      var prevCount = this._count;
      this._count = count;
      document.querySelectorAll('[data-sg-bag]').forEach(function (bag) {
        bag.classList.toggle('has-items', cart.item_count > 0);
        if (prevCount != null && count > prevCount) { bag.classList.remove('is-bump'); void bag.offsetWidth; bag.classList.add('is-bump'); }
        var n = bag.querySelector('[data-sg-cart-count]');
        if (n) n.textContent = count > 0 ? Math.min(count, 99) : '';
      });
      this.classList.toggle('is-empty', count === 0);

      // threshold and shipping are set in the store currency; convert them to the shopper's market currency
      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
      var th = Math.round((cartCfg.threshold || 8000) * rate), total = cart.total_price, left = Math.max(th - total, 0);
      var pct = Math.min(100, Math.round(total / th * 100));
      var ship = q('[data-sg-ship]');
      ship.hidden = cart.item_count === 0;
      ship.classList.toggle('is-done', left === 0);
      q('[data-sg-ship-text]').innerHTML = left === 0 ? esc(cartCfg.doneText) : esc(cartCfg.goalText).replace('[amount]', '<b>' + esc(shopMoney(left)) + '</b>');
      var bar = q('[data-sg-ship-bar]');
      bar.style.setProperty('--p', pct + '%');
      bar.setAttribute('aria-valuenow', pct);

      var body = q('[data-sg-drawer-items]'), foot = q('[data-sg-drawer-foot]');
      if (!cart.items.length) {
        body.innerHTML = '<div class="sg-drawer__empty"><h3 class="sg-x">' + esc(cartCfg.emptyTitle) + '</h3><p>' + esc(cartCfg.emptyText) + '</p>' +
          '<a class="sg-btn sg-btn--orange" href="' + esc(cartCfg.emptyUrl || cartRoot) + '">' + esc(cartCfg.emptyCta) + '</a></div>';
        var tpl = this.querySelector('[data-sg-lens-mini]');
        if (tpl && tpl.content) body.querySelector('.sg-drawer__empty').appendChild(tpl.content.cloneNode(true));
        foot.hidden = true;
        var emptySlot = q('[data-sg-drawer-upsell]');
        if (emptySlot) { emptySlot.hidden = true; emptySlot.innerHTML = ''; }
        return;
      }
      foot.hidden = false;
      var shipCost = left === 0 ? 0 : Math.round((cartCfg.shipping || 0) * rate);
      // code discounts: cart-level (order discounts) + line-level (product discounts); automatic bundle discounts stay on the lines
      var byCode = {}, lineCode = 0;
      (cart.cart_level_discount_applications || []).forEach(function (a) {
        // /cart.js gives { type, title, total_allocated_amount }, /cart/update.js gives { amount, discount_application }
        var app = a.discount_application || a, amt = a.amount != null ? a.amount : a.total_allocated_amount;
        if (app.type === 'discount_code') byCode[app.title] = (byCode[app.title] || 0) + (amt || 0);
      });
      cart.items.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (al) {
          if (al.discount_application && al.discount_application.type === 'discount_code') {
            byCode[al.discount_application.title] = (byCode[al.discount_application.title] || 0) + al.amount;
            lineCode += al.amount;
          }
        });
      });
      var sub = (cart.items_subtotal_price != null ? cart.items_subtotal_price : total) + lineCode;
      q('[data-sg-drawer-subtotal]').textContent = shopMoney(sub);
      var codesEl = q('[data-sg-drawer-codes]');
      if (codesEl) {
        codesEl.innerHTML = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
          var amt = byCode[d.code] || Object.keys(byCode).reduce(function (m, k) { return k.toLowerCase() === d.code.toLowerCase() ? byCode[k] : m; }, 0);
          if (!amt && Object.keys(byCode).length === 0) amt = Math.max(0, sub - total); // last resort: whatever the codes took off
          return '<div class="sg-drawer__code"><span><button type="button" data-sg-code-remove="' + esc(d.code) + '" aria-label="Remove ' + esc(d.code) + '">✕</button>' +
            esc(d.code.toUpperCase()) + '</span><b>−' + esc(shopMoney(amt)) + '</b></div>';
        }).join('');
      }
      var sh = q('[data-sg-drawer-shipping]');
      sh.textContent = shipCost === 0 ? (cartCfg.freeLabel || 'FREE') : shopMoney(shipCost);
      sh.classList.toggle('is-free', shipCost === 0);
      q('[data-sg-drawer-total]').textContent = shopMoney(total + shipCost);

      var upSlot = q('[data-sg-drawer-upsell]');
      if (upSlot) upSlot.hidden = !up;
      body.innerHTML = items.map(function (it) {
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sg-line__v">' + esc(it.variant_title) + '</div>' : '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + esc(shopMoney(it.original_line_price)) + '</s>' : '';
        return '<div class="sg-line" data-key="' + esc(it.key) + '">' +
          '<a class="sg-line__img" href="' + esc(it.url) + '" tabindex="-1">' + lineThumb(it) + '</a>' +
          '<div><a class="sg-line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="sg-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div></div>' +
          '<div class="sg-line__r"><b>' + esc(shopMoney(it.final_line_price)) + '</b>' + was + '<button type="button" class="sg-line__rm" data-q="0">Remove</button></div></div>';
      }).join('');
      var upHtml = (up ? '<label class="sg-up' + (upLine ? ' is-on' : '') + '">' +
          '<input type="checkbox" class="sg-up__cb" data-sg-upsell-toggle' + (upLine ? ' checked' : '') + '>' +
          '<span class="sg-up__txt"><b>' + esc(up.title) + '</b>' + (up.text ? '<small>' + esc(up.text) + '</small>' : '') + '</span>' +
          '<span class="sg-up__side"><b class="sg-up__price">' + esc(shopMoney(upLine ? upLine.final_line_price : up.price)) + '</b>' +
          '<span class="sg-up__btn" aria-hidden="true">' + (upLine ? '✕' : '+ Add') + '</span></span></label>' : '');
      if (upSlot) upSlot.innerHTML = upHtml; else body.insertAdjacentHTML('beforeend', upHtml);
    }
    open() {
      var self = this;
      this.lastFocus = this.activeElement || document.activeElement;
      this.load();
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sg-drawer-open');
      setTimeout(function () { self.panel && self.panel.focus(); }, 60);
      return true;
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sg-drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', SgCartDrawer);

  /* ---------- compare slider ---------- */
  function initCompare(root) {
    root.querySelectorAll('[data-sg-compare]').forEach(function (el) {
      if (el.dataset.sgReady) return;
      el.dataset.sgReady = '1';
      var range = el.querySelector('input[type="range"]');
      if (!range) return;
      var raf = 0, next = range.value, drag = false;
      var paint = function () { raf = 0; el.style.setProperty('--x', next + '%'); };
      var set = function (pct) {
        next = Math.max(0, Math.min(100, pct));
        range.value = next;
        if (!raf) raf = requestAnimationFrame(paint);
      };
      range.addEventListener('input', function () { set(+range.value); });
      // drag anywhere on the image (not just on the invisible thumb); vertical swipes still scroll the page
      var at = function (e) { var r = el.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); };
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.pointerType === 'mouse') e.preventDefault(); // no native image drag / text selection on desktop
        drag = true;
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
        at(e);
      });
      el.addEventListener('pointermove', function (e) { if (drag) at(e); });
      var stop = function () { drag = false; };
      el.addEventListener('pointerup', stop);
      el.addEventListener('pointercancel', stop);
      el.addEventListener('lostpointercapture', stop);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
      set(+range.value);
    });
  }

  /* ---------- dialogs (lens guide, fit guide) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sg-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-sg-open'));
      if (d && d.showModal) { d.showModal(); }
      return;
    }
    if (e.target.closest('[data-sg-close]')) { closeDialog(e.target.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('sg-dialog')) { closeDialog(e.target); }
  });

  // drawer-style dialogs slide out before closing
  function closeDialog(d) {
    if (!d) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!d.classList.contains('sg-dialog--drawer') || reduce) { d.close(); return; }
    if (d.classList.contains('is-closing')) return;
    d.classList.add('is-closing');
    setTimeout(function () { d.classList.remove('is-closing'); d.close(); }, 260);
  }
  document.addEventListener('cancel', function (e) {
    var d = e.target;
    if (d && d.classList && d.classList.contains('sg-dialog--drawer')) { e.preventDefault(); closeDialog(d); }
  }, true);

  /* ---------- delivery estimate ---------- */
  function isBusiness(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (isBusiness(d)) n--; }
    return d;
  }
  function fmtDay(d) { return d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\.$/, ''); }
  function renderDelivery(el) {
    var cutoff = parseInt(el.dataset.cutoff, 10) || 14;
    var min = parseInt(el.dataset.min, 10) || 1;
    var max = parseInt(el.dataset.max, 10) || 3;
    var now = new Date();
    var shipsToday = isBusiness(now) && now.getHours() < cutoff;
    var ship = new Date(now);
    if (!shipsToday) { ship = addBusinessDays(new Date(now.getFullYear(), now.getMonth(), now.getDate()), 1); }
    // ship date only, no arrival estimate
    var text;
    if (shipsToday) {
      var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
      var mins = Math.max(0, Math.round((end - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      text = 'Ships today if you order within <span>' + (h ? h + ' h ' : '') + m + ' min</span>';
    } else {
      text = 'Ships ' + fmtDay(ship);
    }
    var eta = el.querySelector('[data-sg-eta]');
    if (eta) eta.innerHTML = '<b>' + text + '</b>';
  }
  function initDelivery(root) {
    root.querySelectorAll('[data-sg-delivery]').forEach(function (el) {
      renderDelivery(el);
      if (!el.dataset.sgReady) { el.dataset.sgReady = '1'; setInterval(function () { renderDelivery(el); }, 60000); }
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-sg-sticky]') || document.querySelector('[data-sg-sticky]');
    if (!bar || bar.dataset.sgReady) return;
    var mainBtn = document.querySelector('product-info [id^="ProductSubmitButton-"]');
    if (!mainBtn) return;
    bar.dataset.sgReady = '1';
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    io.observe(mainBtn);
    bar.querySelector('[data-sg-sticky-btn]').addEventListener('click', function () {
      if (bar.dataset.mode !== 'add') {
        var target = document.querySelector('.kaching-bundles') || document.querySelector('.sg-bundle') || document.querySelector('variant-selects') || document.querySelector('product-info .product-form');
        if (target) {
          var y = target.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
        return;
      }
      var btn = document.querySelector('product-info [id^="ProductSubmitButton-"]');
      if (btn && !btn.disabled) btn.click();
    });
  }

  /* ---------- lens info ---------- */
  function updateLens(variant) {
    document.querySelectorAll('[data-sg-lens]').forEach(function (box) {
      var data;
      try { data = JSON.parse(box.querySelector('[data-sg-lens-data]').textContent); } catch (e) { return; }
      var kw = box.dataset.kw;
      if (kw && (variant.title || '').toLowerCase().indexOf(kw) !== -1) {
        box.hidden = false;
        box.querySelector('[data-sg-lens-name]').textContent = box.dataset.kitName;
        box.querySelector('[data-sg-lens-best]').textContent = box.dataset.kitBest;
        box.querySelector('[data-sg-lens-desc]').textContent = box.dataset.kitDesc;
        box.querySelector('[data-sg-lens-color]').style.background = box.dataset.kitColor;
        return;
      }
      var opts = (variant && variant.options || []).map(function (o) { return String(o).toLowerCase(); });
      var hit = data.find(function (l) {
        var n = (l.name || '').toLowerCase();
        return n && opts.some(function (o) { return o.indexOf(n) !== -1; });
      });
      if (!hit) { box.hidden = true; return; }
      box.hidden = false;
      box.querySelector('[data-sg-lens-name]').textContent = hit.name;
      box.querySelector('[data-sg-lens-best]').textContent = hit.best;
      box.querySelector('[data-sg-lens-desc]').textContent = hit.desc;
      box.querySelector('[data-sg-lens-color]').style.background = hit.color;
    });
  }


  /* ---------- bundle offer (single pair vs kit) ---------- */
  function initBundle(root) {
    root.querySelectorAll('[data-sg-bundle]').forEach(function (el) {
      if (el.dataset.sgReady) return;
      el.dataset.sgReady = '1';
      var info = el.closest('product-info') || document.body;
      var kitValue = el.dataset.kitValue;
      var radios = function () { return Array.prototype.slice.call(info.querySelectorAll('variant-selects input[type="radio"]')); };
      var kitInput = function () { return kitValue ? radios().find(function (r) { return r.value === kitValue; }) : null; };
      var lastSingle = null;
      var setState = function (isKit) {
        el.querySelectorAll('[data-sg-offer]').forEach(function (b) {
          b.setAttribute('aria-checked', String((b.dataset.sgOffer === 'kit') === isKit));
        });
        info.classList.toggle('sg-kit-on', isKit && !!kitValue);
      };
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sg-offer]');
        if (!b) return;
        var isKit = b.dataset.sgOffer === 'kit';
        setState(isKit);
        var k = kitInput();
        if (!k) return; /* example mode: visual only */
        if (isKit) { if (!k.checked) k.click(); return; }
        var group = radios().filter(function (r) { return r.name === k.name && r.value !== kitValue; });
        var target = group.find(function (r) { return r.value === lastSingle; }) || group[0];
        if (target && !target.checked) target.click();
      });
      el._sgVariant = function (variant) {
        var isKit = (variant.title || '').toLowerCase().indexOf(el.dataset.kw) !== -1;
        if (!isKit) {
          var k = kitInput();
          var sel = k && radios().find(function (r) { return r.name === k.name && r.checked; });
          if (sel) lastSingle = sel.value;
        }
        setState(isKit);
      };
      var start = el.querySelector('[data-sg-offer="kit"]').getAttribute('aria-checked') === 'true';
      setState(start);
      if (start && kitValue) { var k0 = kitInput(); if (k0 && !k0.checked) k0.click(); }
    });
  }

  /* ---------- PDP fallback photo follows the selected lens ---------- */
  function swapPdpPhoto(variant) {
    var slot = document.querySelector('[data-sg-pdp-photo] img');
    if (!slot || !variant) return;
    var t = (variant.title || '').toLowerCase();
    var ph = cartCfg.photosLarge || {}, sm = cartCfg.photos || {}, lenses = cartCfg.lenses || [];
    var k = null;
    if (cartCfg.kitKeyword && t.indexOf(cartCfg.kitKeyword) !== -1) k = 'kit';
    else {
      var idx = lenses.findIndex(function (l) { return t.indexOf(l.name) !== -1; });
      if (idx > -1 && idx < 3) k = 'l' + (idx + 1);
    }
    if (!k || !ph[k]) return;
    slot.srcset = sm[k] + ' 800w, ' + ph[k] + ' 1600w';
    slot.src = ph[k];
  }

  /* ---------- variant change (Dawn pubsub) ---------- */
  function onVariant(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-sg-klarna]').forEach(function (el) {
      var n = parseInt(el.dataset.n, 10) || 3;
      var amt = el.querySelector('[data-sg-klarna-amount]');
      if (amt) amt.textContent = money(Math.round(variant.price / n), el.dataset.currency);
    });
    var bar = document.querySelector('[data-sg-sticky]');
    if (bar) {
      bar.querySelector('[data-sg-sticky-price]').textContent = money(variant.price, bar.dataset.currency);
      var vt = bar.querySelector('[data-sg-sticky-variant]');
      if (vt && variant.title && variant.title !== 'Default Title') vt.textContent = variant.title;
      var b = bar.querySelector('[data-sg-sticky-btn]');
      if (bar.dataset.mode === 'add') {
        b.disabled = !variant.available;
        bar.querySelector('[data-sg-sticky-label]').textContent =
          variant.available ? bar.dataset.label : ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out');
      }
    }
    updateLens(variant);
    swapPdpPhoto(variant);
    document.querySelectorAll('[data-sg-bundle]').forEach(function (el) { if (el._sgVariant) el._sgVariant(variant); });
  }


  /* ---------- UGC review carousel + lightbox ---------- */
  function initUgc(root) {
    root.querySelectorAll('[data-sg-ugc]').forEach(function (sec) {
      if (sec.dataset.sgReady) return;
      sec.dataset.sgReady = '1';
      var track = sec.querySelector('[data-sg-ugc-track]');
      var items = Array.prototype.slice.call(track.children);
      var prev = sec.querySelector('[data-sg-ugc-prev]'), next = sec.querySelector('[data-sg-ugc-next]');
      var bar = sec.querySelector('[data-sg-ugc-bar]');
      var step = function () { return items[0] ? items[0].getBoundingClientRect().width + 12 : 300; };
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        var w = track.scrollWidth ? Math.max(12, (track.clientWidth / track.scrollWidth) * 100) : 100;
        if (bar) { bar.style.width = w + '%'; bar.style.left = p * (100 - w) + '%'; }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      /* muted autoplay while in view */
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
          });
        }, { threshold: 0.6 });
        track.querySelectorAll('video').forEach(function (v) { v.muted = true; io.observe(v); });
      }

      /* lightbox (optional) */
      var dialog = sec.querySelector('[data-sg-ugc-dialog]');
      if (!dialog) return;
      var content = dialog.querySelector('[data-sg-ugc-lb-content]');
      var count = dialog.querySelector('[data-sg-ugc-count]');
      var current = 0;
      var show = function (i) {
        current = (i + items.length) % items.length;
        var tpl = items[current].querySelector('template[data-sg-ugc-full]');
        content.innerHTML = '';
        content.appendChild(tpl.content.cloneNode(true));
        count.textContent = (current + 1) + ' / ' + items.length;
        var v = content.querySelector('video');
        if (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      };
      items.forEach(function (item, i) {
        item.querySelector('[data-sg-ugc-open]').addEventListener('click', function () {
          show(i);
          if (dialog.showModal) dialog.showModal();
        });
      });
      dialog.querySelector('[data-sg-ugc-lb-prev]').addEventListener('click', function () { show(current - 1); });
      dialog.querySelector('[data-sg-ugc-lb-next]').addEventListener('click', function () { show(current + 1); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
      dialog.addEventListener('close', function () { content.innerHTML = ''; });
    });
  }


  /* ---------- giant wordmark: always fit the row, whatever the name length ---------- */
  function fitWordmarks() {
    document.querySelectorAll('.sg-wordmark').forEach(function (el) {
      var txt = el.querySelector('span') || el;
      el.style.fontSize = '100px';
      var w = el.clientWidth;
      var tw = txt.getBoundingClientRect().width;
      if (tw > 0 && w > 0) el.style.fontSize = Math.floor(100 * w / tw * 0.98) + 'px';
      el.classList.add('is-fit');
    });
  }
  window.addEventListener('resize', function () { window.requestAnimationFrame(fitWordmarks); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWordmarks);

  /* ---------- before / after gallery ---------- */
  function initBa(root) {
    root.querySelectorAll('[data-sg-ba]').forEach(function (el) {
      if (el.dataset.sgBaReady) return;
      el.dataset.sgBaReady = '1';
      var tabs = [].slice.call(el.querySelectorAll('[data-sg-ba-tab]'));
      var panels = [].slice.call(el.querySelectorAll('[data-sg-ba-panel]'));
      var num = el.querySelector('[data-sg-ba-num]');
      var title = el.querySelector('[data-sg-ba-title]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;
      function sweep(panel) {
        var range = panel.querySelector('input[type="range"]');
        if (!range) return;
        if (reduce) { range.value = 50; range.dispatchEvent(new Event('input')); return; }
        var start = null, from = 88, to = 50, dur = 700;
        function step(t) {
          if (start === null) start = t;
          var p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
          range.value = from + (to - from) * e;
          range.dispatchEvent(new Event('input'));
          if (p < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
      function show(i, focus) {
        if (!tabs.length) return;
        current = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, k) {
          t.setAttribute('aria-selected', k === current ? 'true' : 'false');
          t.tabIndex = k === current ? 0 : -1;
        });
        panels.forEach(function (p, k) { p.hidden = k !== current; });
        if (num) num.textContent = (current + 1 < 10 ? '0' : '') + (current + 1);
        if (title) title.textContent = tabs[current].dataset.title || '';
        var tab = tabs[current], rail = tab.parentElement;
        if (rail.scrollWidth > rail.clientWidth) rail.scrollTo({ left: tab.offsetLeft - rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        if (focus) tab.focus();
        if (panels[current]) sweep(panels[current]);
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { show(k); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); show(k + 1, true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); show(k - 1, true); }
        });
      });
      var prev = el.querySelector('[data-sg-ba-prev]'), next = el.querySelector('[data-sg-ba-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      tabs.forEach(function (t, k) { t.tabIndex = k === 0 ? 0 : -1; });
      if (title && tabs[0]) title.textContent = tabs[0].dataset.title || '';
    });
  }

  /* ---------- PDP thumbnails: match the active image width on desktop ---------- */
  function syncThumbs() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      var t = g.querySelector('.thumbnail-slider');
      if (!t) return;
      if (window.innerWidth < 750) { t.style.removeProperty('width'); t.style.removeProperty('margin-inline'); return; }
      var a = g.querySelector('.product__media-item.is-active .product-media-container') || g.querySelector('.product__media-item .product-media-container');
      var w = a ? a.getBoundingClientRect().width : 0;
      if (!w) return;
      t.style.width = Math.round(w) + 'px';
      t.style.marginInline = 'auto';
      g.style.setProperty('--sg-media-w', Math.round(w) + 'px');
      var sc = a.closest('slider-component'), ar = a.getBoundingClientRect();
      if (sc) g.style.setProperty('--sg-media-mid', Math.round(ar.top - sc.getBoundingClientRect().top + ar.height / 2) + 'px');
    });
  }
  function initThumbs(root) {
    root.querySelectorAll('media-gallery').forEach(function (g) {
      if (g.dataset.sgThumbs) return;
      g.dataset.sgThumbs = '1';
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { window.requestAnimationFrame(syncThumbs); });
        g.querySelectorAll('.product-media-container').forEach(function (c) { ro.observe(c); });
      }
      g.addEventListener('click', function (e) { if (e.target.closest('.thumbnail')) window.requestAnimationFrame(syncThumbs); });
    });
    syncThumbs();
  }
  window.addEventListener('resize', function () { window.requestAnimationFrame(syncThumbs); });
  // "Get the 3-Lens Kit": scroll to the buy box and pick the kit option (Kaching bar or Signal bundle)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sg-buy-kit]');
    if (!a) return;
    e.preventDefault();
    var target = document.querySelector('.kaching-bundles') || document.querySelector('.sg-bundle') || document.querySelector('product-form') || document.querySelector('.product__info-container');
    if (!target) return;
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    for (var i = 0; i < bars.length; i++) {
      var t = bars[i].querySelector('.kaching-bundles__bar-title');
      if (t && /kit|3/i.test(t.textContent)) { var lab = bars[i].querySelector('label'); if (lab) lab.click(); break; }
    }
    var kitOffer = document.querySelector('.sg-offer--kit');
    if (kitOffer && !bars.length) kitOffer.click();
    var y = target.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  // thumbnails can be re-rendered on variant change, so handle their clicks by delegation
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[id^="GalleryThumbnails"] [data-target]');
    if (!item) return;
    var g = item.closest('media-gallery');
    if (g && g.setActiveMedia) { g.setActiveMedia(item.dataset.target, false); window.requestAnimationFrame(syncThumbs); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sg-gal]');
    if (!btn) return;
    var g = btn.closest('media-gallery');
    if (!g) return;
    var thumbs = [].slice.call(g.querySelectorAll('.thumbnail-list__item .thumbnail')).filter(function (b) { return b.offsetParent !== null; });
    if (thumbs.length < 2) return;
    var i = thumbs.findIndex(function (b) { return b.hasAttribute('aria-current'); });
    var next = thumbs[((i < 0 ? 0 : i) + Number(btn.dataset.sgGal) + thumbs.length) % thumbs.length];
    next.click();
    window.requestAnimationFrame(syncThumbs);
  });

  function init(root) {
    root = root || document;
    initCompare(root);
    initBa(root);
    initThumbs(root);
    initDelivery(root);
    initSticky(root);
    initUgc(root);
    initBundle(root);
    fitWordmarks();
  }

  /* ---------- urgency line on the Kaching kit bundle (Theme settings → urgency line on the kit) ---------- */
  // pairs in a Kaching bar from its title: "3-PAIR KIT" = 3, "2-PAIR KIT" = 2, "1 PAIR" = 1; a kit title without a number counts as 3
  function barPairs(title, kw) {
    // "BUY 2 GET 1 FREE" / "2 PAIRS + GET 1 FREE" = 3 pairs, "BUY 2 GET 3" = 3 pairs, "3-PAIR KIT" = 3, "1 PAIR" = 1
    var t = (title || '').toLowerCase(), bg = t.match(/(?:buy\s*)?(\d+)\D+?get\s*(\d+)(\s*free)?/), m = t.match(/\d+/g);
    if (bg) { var x = parseInt(bg[1], 10), y = parseInt(bg[2], 10); return bg[3] ? x + y : Math.max(x, y); }
    if (m) return Math.max.apply(null, m.map(function (n) { return parseInt(n, 10); }));
    return t.indexOf(kw) !== -1 ? 3 : 1;
  }

  function initUrgency() {
    var u = window.SgUrgency;
    if (!u || !u.show) return;
    var kw = (cartCfg.kitKeyword || 'kit').toLowerCase();
    function place() {
      document.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar').forEach(function (bar) {
        var title = bar.querySelector('.kaching-bundles__bar-title');
        var wrap0 = bar.querySelector('.kaching-bundles__bar-wrapper > .sg-urgency');
        if (!title || barPairs(title.textContent, kw) < 3) { if (wrap0) wrap0.remove(); return; }
        var wrap = bar.querySelector('.kaching-bundles__bar-wrapper');
        if (!wrap || wrap.querySelector(':scope > .sg-urgency')) return;
        var el = document.createElement('div');
        el.className = 'sg-urgency';
        var parts = esc(u.text).split('{time}');
        el.innerHTML = '<i aria-hidden="true"></i><span>' + parts[0] + (parts.length > 1 ? '<b class="sg-urgency__t">' + left() + '</b>' + parts[1] : '') + '</span>';
        wrap.appendChild(el);
      });
    }
    /* countdown to midnight on the last day of this month, in the shopper's own time ("{time}" in the text) */
    function left() {
      var now = new Date(), end = new Date(now.getFullYear(), now.getMonth() + 1, 1), s = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor(s / 3600) % 24, m = Math.floor(s / 60) % 60, sec = s % 60;
      function p2(n) { return (n < 10 ? '0' : '') + n; }
      return (d ? d + 'd ' : '') + p2(h) + 'h ' + p2(m) + 'm ' + p2(sec) + 's';
    }
    if (u.text.indexOf('{time}') !== -1) {
      setInterval(function () {
        var t = left();
        document.querySelectorAll('.sg-urgency__t').forEach(function (b) { b.textContent = t; });
      }, 1000);
    }
    place();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; place(); }, 60); // not rAF: it pauses in background tabs
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- free-gift lens default per Kaching deal (Kaching has no setting for it) ----------
     Finds the bar that holds the free gift, so it works in every A/B variant of the deal. Each select is set once,
     so a lens the shopper picks is kept. Both deals are set here (the Kaching support script only covered one bar position of the PRO deal). */
  // gift = lens of the free pair, single = lens in the 1-pair bar
  var GIFT_DEFAULTS = {
    '6dcefaf3-28d1-4a5c-b2fc-622a6a1ccb0d': { gift: 'Amber (low light)', single: 'Copper (all-round)' }, // PRO II
    '032c0eb5-8952-48cc-a8ca-8ee203f5e199': { gift: 'Amber (low light)' } // PRO
  };
  function initGiftDefault() {
    var handled = typeof WeakSet === 'function' ? new WeakSet() : null;
    var kw = (cartCfg.kitKeyword || 'kit').toLowerCase();
    var queued = false;
    function pick(select, target) {
      if (!handled || handled.has(select)) return;
      var option = Array.prototype.find.call(select.options, function (o) { return o.value.trim() === target; });
      if (!option) return;
      handled.add(select);
      if (select.value === option.value) return;
      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function apply() {
      queued = false;
      Object.keys(GIFT_DEFAULTS).forEach(function (id) {
        var cfg = GIFT_DEFAULTS[id];
        document.querySelectorAll('[data-deal-block-id="' + id + '"]').forEach(function (block) {
          if (cfg.gift) block.querySelectorAll('.kaching-bundles__free-gift .kaching-bundles__bar-variant-select').forEach(function (sel) { pick(sel, cfg.gift); });
          if (cfg.single) block.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
            var title = bar.querySelector('.kaching-bundles__bar-title');
            if (!title || barPairs(title.textContent, kw) !== 1) return;
            bar.querySelectorAll('.kaching-bundles__bar-variant-select').forEach(function (sel) {
              if (!sel.closest('.kaching-bundles__free-gift')) pick(sel, cfg.single);
            });
          });
        });
      });
    }
    apply();
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(apply, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- stock line under the buy button: kit = "risk of selling out", 1–2 pairs = "in stock" ---------- */
  function initStock() {
    var cfg = window.SgStock;
    if (!cfg) return;
    var kw = (cartCfg.kitKeyword || 'kit').toLowerCase();
    function pairs() {
      var sel = document.querySelector('.kaching-bundles__bars > .kaching-bundles__bar--selected .kaching-bundles__bar-title');
      return sel ? barPairs(sel.textContent, kw) : 0;
    }
    function apply() {
      var risk = pairs() >= 3, key = risk ? 'risk' : 'ok';
      document.querySelectorAll('.product__inventory').forEach(function (el) {
        if (el.dataset.sgStock === key && el.querySelector('.sg-stock')) return;
        el.dataset.sgStock = key;
        el.classList.remove('visibility-hidden');
        el.innerHTML = '<span class="sg-stock sg-stock--' + key + '"><i aria-hidden="true"></i>' + esc(risk ? cfg.risk : cfg.ok) + '</span>';
      });
    }
    apply();
    var queued = false;
    var later = function () { if (queued) return; queued = true; setTimeout(function () { queued = false; apply(); }, 60); };
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) { if (e.target.closest('.kaching-bundles')) { later(); setTimeout(apply, 350); } });
    document.addEventListener('change', function (e) { if (e.target.closest('.kaching-bundles')) later(); });
  }

  /* ---------- prices written into copy ("$17.55 a pair", "free shipping over $45") ----------
     Copy is written in USD. The kit amounts ($52.65 kit, $17.55 a pair) follow the live Kaching kit price, read on the
     product page and remembered per currency. In other currencies the remaining amounts are converted at the market
     rate and get the currency code, so an AUD shopper never reads a USD number as AUD. */
  function initCopyPrices() {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
    var foreign = cur !== 'USD';
    var kw = (cartCfg.kitKeyword || 'kit').toLowerCase();
    var KEY = 'sg_kit_cents_' + cur;
    var SKIP = 'script,style,textarea,input,select,.price,[class*="kaching"],.sg-drawer,.cart-drawer,[data-sg-sticky-price],.sg-sticky__price,.totals,.cart-item,.sg-scratch';
    var done = typeof WeakSet === 'function' ? new WeakSet() : null;
    var kit = null;
    try { kit = parseInt(localStorage.getItem(KEY), 10) || null; } catch (e) {}

    function readKit() {
      var found = null;
      document.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar').forEach(function (bar) {
        var title = bar.querySelector('.kaching-bundles__bar-title'), price = bar.querySelector('.kaching-bundles__bar-price');
        if (!title || !price || barPairs(title.textContent, kw) < 3) return;
        var n = parseFloat(price.textContent.replace(/[^0-9.,]/g, '').replace(/,(\d{2})$/, '.$1').replace(/,/g, ''));
        if (n > 0) found = Math.round(n * 100);
      });
      if (found) { kit = found; try { localStorage.setItem(KEY, String(found)); } catch (e) {} }
      return found;
    }
    function fmt(v, exact) {
      var cents = exact || v % 1 !== 0;
      var str = '$' + (cents ? v.toFixed(2) : String(v));
      return str;
    }
    function nice(v) { return v < 20 ? Math.round(v) : Math.round(v / 5) * 5; }
    function convert(text) {
      var changed = false;
      var out = text.replace(/\$(\d+(?:\.\d{2})?)(?:(\s?[–-]\s?)(\d+))?(\+)?/g, function (all, a, dash, b, plus) {
        var v = parseFloat(a), res;
        if (kit && (a === '52.65' || a === '17.55')) {
          res = fmt((a === '52.65' ? kit : kit / 3) / 100, true);
        } else if (!foreign) {
          return all;
        } else if (cartCfg.threshold && Math.round(v * 100) === cartCfg.threshold) {
          res = fmt(Math.ceil(v * rate)); // free-shipping line: round up, never promise less than the cart asks for
        } else if (/\./.test(a)) {
          res = fmt(v * rate, true);
        } else {
          res = fmt(nice(v * rate)) + (b ? dash + nice(parseFloat(b) * rate) : '');
        }
        changed = true;
        return res + (plus || '') + (foreign ? ' ' + cur : '');
      });
      return changed ? out : null;
    }
    function run(root) {
      var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (n.nodeValue.indexOf('$') === -1 || (done && done.has(n))) return NodeFilter.FILTER_REJECT;
          var el = n.parentElement;
          return el && !el.closest(SKIP) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        var next = convert(node.nodeValue);
        if (next !== null) node.nodeValue = next;
        if (done) done.add(node);
      });
    }

    var onPdp = !!document.querySelector('.kaching-bundles, [data-sg-delivery]') && /\/products\//.test(location.pathname);
    var tries = 0;
    (function start() {
      // on the product page, wait briefly for Kaching so the kit price is the live one
      if (onPdp && !readKit() && tries++ < 20) { setTimeout(start, 200); return; }
      if (!kit && !foreign) return;
      run();
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; run(); }, 120);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    })();
  }

  /* ---------- market selector in the header ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sg-country-btn]');
    document.querySelectorAll('[data-sg-country]').forEach(function (box) {
      var b = box.querySelector('[data-sg-country-btn]'), list = box.querySelector('.sg-country__list');
      var open = btn === b && b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sg-country-btn][aria-expanded="true"]').forEach(function (b) { b.click(); b.focus(); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initUrgency();
    initGiftDefault();
    initStock();
    initCopyPrices();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) { onVariant(e.data && e.data.variant); });
    }
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
